import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import FieldCheckbox from '../../fields/FieldCheckbox';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../../lang/main';
import useFormState from '../../FormStateHelper';
import { validateForm } from '../../../selectors/defaultSelectors';
import {
    createModal,
    showModal,
} from '../../../dom/components/confirm-removal-modal';
import {
    setReAuth,
    submitReAuthPasswordInformation,
} from '../../../actions/userActions';

const FORM_LABEL = {
    ProvidesCardPaymentMethod: getTranslation('FIELD.CREDIT_CARD'),
    ProvidesAccountPaymentMethod: getTranslation('FIELD.CHARGE_ACCOUNT'),
    ProvidesPayFastMethod: getTranslation('FIELD.PAYFAST'),
};

function AccountResellerPaymentMethodsForm(props) {
    const { data, handleFormSubmission, userReAuth, setReAuthChecked } = props;
    const {
        formData,
        updateFormData,
        bindUpdateFormData,
        isSubmitting,
        submitForm,
    } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {},
    });
    const [isValidated, setIsValidated] = useState(false);
    const [checked, setChecked] = React.useState(false);
    let fieldRefs = {};

    const finalFormData = {
        ...data,
        ...formData,
    };
    const onFormSubmit = (e) => {
        e.preventDefault();

        submitForm(finalFormData);
    };
    const onFieldUpdate = (e) => {
        e.preventDefault();
        updateFormData(e.target.name, String(e.target.value) == 'true');
    };

    const onFieldProvideUpdate = (e) => {
        e.preventDefault();
        $('#re-authenticate-password').modal('show');
        // if (!finalFormData.ProvidesAccountPaymentMethod) {
        //     $('#re-authenticate-password').modal('show');
        // }
        // else {
        //     updateFormData(e.target.name, String(e.target.value) == 'true');
        // }
        
    };

    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {
        setIsValidated(!validateForm(fieldRefs));
    }, [finalFormData]);

    useEffect(() => {
        if (userReAuth) {
            if (finalFormData.ProvidesAccountPaymentMethod) { 
                updateFormData('ProvidesAccountPaymentMethod', 'false' == 'true');     
            }
            else {
                updateFormData('ProvidesAccountPaymentMethod', 'true' == 'true');
            }
        } else {
            if (!finalFormData.ProvidesAccountPaymentMethod) { 
                updateFormData('ProvidesAccountPaymentMethod', 'true' == 'true');
            }
            else {
                updateFormData('ProvidesAccountPaymentMethod', 'false' == 'true');
            }
        }
        // }
    }, [userReAuth]);

    useEffect(() => {
        if (finalFormData.ProvidesAccountPaymentMethod) {
            updateFormData('ProvidesAccountPaymentMethod', 'true' == 'true');
        }
        if (!finalFormData.ProvidesAccountPaymentMethod) {
            updateFormData('ProvidesAccountPaymentMethod', 'false' == 'true');
        }
    }, []);
    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-merchant' />
                    </span>
                </span>
                <h3 className='heading heading--lv4'>
                    <LocalizedMessage
                        id={'ACCOUNT_RESELLER_PAYMENT_METHODS_FORM.HEADING'}
                    />
                </h3>
            </div>
            <div className='vspace vspace--small'>
                <div className='text-box'>
                    <p>
                        <LocalizedMessage
                            id={'ACCOUNT_RESELLER_PAYMENT_METHODS_FORM.CONTENT'}
                        />
                    </p>
                </div>
            </div>
            <form className='form' onSubmit={onFormSubmit}>
                <div className='row'>
                    <div className='col-xs-12 col-md-7 vspace vspace--small'>
                        {window.localeCountry != 'South Africa' ?
                        <FieldCheckbox
                            ref={(r) =>
                                (fieldRefs.ProvidesCardPaymentMethod = r)
                            }
                            checked={finalFormData.ProvidesCardPaymentMethod}
                            label={FORM_LABEL['ProvidesCardPaymentMethod']}
                            name='ProvidesCardPaymentMethod'
                            value={!finalFormData.ProvidesCardPaymentMethod}
                            onChange={onFieldUpdate}
                        />
                        :
                        <FieldCheckbox
                            ref={(r) =>
                                (fieldRefs.ProvidesCardPaymentMethod = r)
                            }
                            checked={finalFormData.ProvidesCardPaymentMethod}
                            label={FORM_LABEL['ProvidesPayFastMethod']}
                            name='ProvidesCardPaymentMethod'
                            value={!finalFormData.ProvidesCardPaymentMethod}
                            onChange={onFieldUpdate}
                        />
                        }
                        {(window.memberType == 'Reseller' && window.localeCountry == 'United States') ? (
                            <FieldCheckbox
                                ref={(r) =>
                                    (fieldRefs.ProvidesAccountPaymentMethod = r)
                                }
                                checked={
                                    // userReAuth ?
                                    //   checked
                                    finalFormData.ProvidesAccountPaymentMethod
                                }
                                label={
                                    FORM_LABEL['ProvidesAccountPaymentMethod']
                                }
                                name='ProvidesAccountPaymentMethod'
                                value={
                                    !finalFormData.ProvidesAccountPaymentMethod
                                }
                                onChange={onFieldProvideUpdate}
                            />
                        ) : (
                            <FieldCheckbox
                                ref={(r) =>
                                    (fieldRefs.ProvidesAccountPaymentMethod = r)
                                }
                                checked={
                                    finalFormData.ProvidesAccountPaymentMethod
                                }
                                label={
                                    FORM_LABEL['ProvidesAccountPaymentMethod']
                                }
                                name='ProvidesAccountPaymentMethod'
                                value={
                                    !finalFormData.ProvidesAccountPaymentMethod
                                }
                                onChange={onFieldUpdate}
                            />
                        )}

                        <button
                            type='submit'
                            className={`form__submit button ${
                                !isValidated ? 'button--disabled' : ''
                            }`}
                            disabled={!isValidated}
                        >
                            <span
                                style={{
                                    opacity: isSubmitting === true ? 0 : 1,
                                }}
                            >
                                <LocalizedMessage id={'SAVE'} />
                            </span>
                            {isSubmitting === true && (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
}

export default AccountResellerPaymentMethodsForm;
